export type GenerationBrief = {
  client: string;
  platform: string;
  audience?: string;
  tone?: string;
};

export function buildGenerationPayload(input: {
  script: string;
  brief: GenerationBrief;
  selectedIds: string[];
}) {
  return {
    script: input.script.trim(),
    brief: input.brief,
    sourceIds: [...new Set(input.selectedIds)]
  };
}

export function buildFeedbackPayload(input: {
  rating: number;
  selected: boolean;
  original: { title: string; coverCopy: string };
  edited: { title: string; coverCopy: string };
}) {
  const edited: Record<string, string> = {};
  if (input.edited.title !== input.original.title) {
    edited.title = input.edited.title;
  }
  if (input.edited.coverCopy !== input.original.coverCopy) {
    edited.coverCopy = input.edited.coverCopy;
  }
  return {
    rating: input.rating,
    selected: input.selected,
    edited
  };
}
